var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.5 2C21.98 2 24 4.02 24 6.5v15c0 2.48-2.02 4.5-4.5 4.5h-2.94v-9.3h3.1l.48-3.62h-3.58v-2.3c0-1.06.28-1.76 1.8-1.76l1.9-.02V5.77c-.32-.05-1.46-.14-2.78-.14-2.76 0-4.67 1.68-4.67 4.78v2.7H9.7v3.6h3.1V26H4.5C2.02 26 0 23.98 0 21.5v-15C0 4.02 2.02 2 4.5 2h15z"}));
}

IconFacebook.displayName = "IconFacebook";

IconFacebook.defaultProps = {"width":"24","height":"28","viewBox":"0 0 24 28"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
